import { forwardRef } from "react";
import PropTypes from "prop-types";
import MDAvatarRoot from "components/MDAvatar/MDAvatarRoot";
import { baseUrl } from "services/axiosInstance";
import profileDefault from "assets/images/Profile-default.jpg";

const MDAvatar = forwardRef(({ bgColor, size, shadow, src, ...rest }, ref) => {
  // Prepend the base URL to the src if it is provided
  const imageSrc = src ? `${baseUrl}${src}` :profileDefault ;

  return (
    <MDAvatarRoot
      ref={ref}
      ownerState={{ shadow, bgColor, size }}
      src={imageSrc}
      {...rest}
    />
  );
});

// Setting default values for the props of MDAvatar
MDAvatar.defaultProps = {
  bgColor: "transparent",
  size: "md",
  shadow: "none",
  src: undefined, // Default src is undefined, which will trigger the default profile image
};

// Typechecking props for the MDAvatar
MDAvatar.propTypes = {
  bgColor: PropTypes.oneOf([
    "transparent",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl"]),
  shadow: PropTypes.oneOf(["none", "xs", "sm", "md", "lg", "xl", "xxl", "inset"]),
  src: PropTypes.string, // src is optional
};

export default MDAvatar;